import React, { FC } from 'react';
import { findIndex, propEq } from 'ramda';
import { useTranslations, TranslationKey } from '@lang';
import { BreadcrumbButton, Wrapper } from './Breadcrumbs.styles';

export type StepLabel = {
  key: string;
  id: TranslationKey;
  defaultMessage?: string;
};

export type BreadcrumbsProps = {
  steps: StepLabel[];
  changeStep: (stepLabel: string) => void;
  currentStepKey: string;
};

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ steps = [], changeStep, currentStepKey }) => {
  const { t } = useTranslations();
  const isStepDisabled = (stepLabel: StepLabel, index: number): boolean => {
    if (stepLabel.key === currentStepKey) {
      return false;
    }

    const currentStepIndex = findIndex(propEq('key', currentStepKey))(steps);
    if (index > currentStepIndex) {
      return true;
    }
    return false;
  };

  return (
    <Wrapper>
      {steps.map(
        (stepLabel, index) =>
          !!stepLabel && (
            <BreadcrumbButton
              type="button"
              key={stepLabel.key}
              onClick={() => changeStep(stepLabel.key)}
              data-testid={stepLabel.key}
              isDisabled={isStepDisabled(stepLabel, index)}
            >
              {t(stepLabel.id)}
            </BreadcrumbButton>
          )
      )}
    </Wrapper>
  );
};
